import React, { useEffect, useState } from "react";
import Input from "../../../../components/Input";
import InputRadio from "../../../../components/InputRadio";
import { getIndexFromObjectArray } from "../../../../helpers/helpers";
import { convertToPercentage } from "../../../../helpers/masks";
import { createOptions } from "../../../../helpers/selects";
import { getUser } from "../../../../services/auth";

const Percentage = ({param, productParams, setProductParams}) => {
    const [index, setIndex] = useState(null);

    useEffect(() => {
        let toIndex = getIndexFromObjectArray(productParams, 'id', param.id);
        setIndex(toIndex);
    }, [productParams]);

    const handleParamChange = value => {
        setProductParams(prev => {
            let toProductParams = [...prev];
            toProductParams[index].value = value;
            return toProductParams;
        });
    }

    let user = getUser();
    let roleId = user?.role ? user.role.id : null;

    return (
        <>
            {index !== null && param.roles.includes(roleId) &&
                <>
                    <div className="modal-section-title">
                        <div className="left">
                            <h2>{param.name}</h2>
                        </div>
                    </div>
                    <div className="section">
                        <div className="row">
                            <div className="col-3">
                                <Input 
                                    label={`Porcentagem`}
                                    value={productParams[index].value ?? convertToPercentage('0')}
                                    change={handleParamChange}
                                    mask={`convertToPercentage`}
                                />
                            </div>
                        </div>
                    </div>
                </>
            }
        </>
    );
}

export default Percentage;